import * as utility from "../services.js"
import * as react_components from "../reactcomponent.js"
import React from "react";
let element: any;

export class JsonTree extends React.Component<any, any> {

    private selectedElement: any;
    constructor(props) {
        super(props);
        this.state = {};
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }
    handleDeleteElement = (row, element) => {
        this.props.onDeleteElement(row, element);
    }

    handleCopyElement = (row, element) => {
        this.props.onCopyElement(row, element);
    }

    handleDeleteRow = (row, parent) => {
        this.props.onDeleteRow(row, parent);
    }

    handleAddListItem = (parent, item) => {
        this.props.onAddListItem(parent, item);
    }

    handleElementClicked = (element) => {
        this.props.onElementClicked(element);
    }

    handleCreateNewElement = (row, type, isParameter) => {
        this.props.onAddElement(row, type, isParameter);
    }

    handleKendoTreeSelect = (e) => {
        //Select event verzögert aufrufen da sonst beim Klick auf den Knoten das Blur Event im PropertiesEditor nicht aufgerufen wird.
        let that = this;
        setTimeout(function () {
            let nodeData = that.state.kendoTreeData.getByUid(e.node.dataset.uid);

            if (nodeData && $.isFunction(nodeData.onSelect)) {
                nodeData.onSelect();
            } else {
                that.handleElementClicked(null);
            }
        }, 10);
        e.preventDefault();
    }

    createParameterGroup = (element) => {
        let that = this;
        return [{ text: "Header", expanded: true, contextMenuData: [{ text: "Add row", onSelect: function () { that.handleAddListItem(element.parameters, { "type": "ROW", "rowItems": [] }) } }], onSelect: null, items: this.createKendoTreeDataNode(element.parameters) },
        { text: "Content", expanded: true, contextMenuData: [{ text: "Add row", onSelect: function () { that.handleAddListItem(element.content, { "type": "ROW", "rowItems": [] }) } }], onSelect: null, items: this.createKendoTreeDataNode(element.content) }];
    }

    createTabControl = (element) => {
        let that = this;
        return [{ text: "Tabs", expanded: true, contextMenuData: [{ text: "Add tab", onSelect: function () { that.handleAddListItem(element.tabs, { "type": "REACTTAB", header: "tab" }) } }], onSelect: null, items: this.createKendoTreeDataNode(element.tabs) }];
    }

    createElements = (row) => {
        return [{ text: "Row", expanded: true, contextMenuData: [{ text: "Row tab", onSelect: function () { this.handleAddListItem(element.tabs, { header: "tab" }) } }], onSelect: null, items: null }];
    }

    handleDrop = (e) => {
        e.preventDefault();

        let sourceNode = this.state.kendoTreeData.getByUid(e.sourceNode.dataset.uid);
        let destinationNode = this.state.kendoTreeData.getByUid(e.destinationNode.dataset.uid);

        if (sourceNode.uid == destinationNode.uid) {
            return;
        }

        let destRowIndex = this.getDestinationRowAndIndex(destinationNode, sourceNode);
        if (destRowIndex) {
            let sourceRow = sourceNode.parentNode().getUiRows();
            this.props.onMoveElement({ row: sourceRow, index: sourceNode.index }, destRowIndex);
        }

    }

    getDestinationRowAndIndex = (destinationNode, sourceNode) => {

        let newDestNode =
            destinationNode.row ?
                destinationNode :
                destinationNode.parentNode() && destinationNode.parentNode().row ?
                    destinationNode.parentNode() :
                    null;

        if (newDestNode && newDestNode.type == "PARAMETERS" && sourceNode.componentType !== utility.ComponentType.InputComponent) {
            return;
        }

        if (newDestNode && newDestNode.row) {
            return { row: newDestNode.getUiRows(), index: destinationNode.index };
        }

    }

    handleDragStart = (e) => {
        let sourceNode = this.state.kendoTreeData.getByUid(e.sourceNode.dataset.uid);
        let parentNode = sourceNode.parentNode();
        if (!parentNode || !parentNode.row) {
            e.preventDefault();
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let kendoTreeData = null;
        this.selectedElement = nextProps.selectedElement;
        if (nextProps.ui) {
            kendoTreeData = this.createKendoTreeData(nextProps.ui);
        }
        this.setState({ kendoTreeData: kendoTreeData });
    }

    createRowMenuItems = (row, rows, isParameter) => {
        let menuItems: any[] = [{ text: "Delete row", onSelect: function () { this.handleDeleteRow(row, rows) } }];
        let components: any[] = [];

        if (utility.InnoCmp) {
            for (let property in utility.InnoCmp) {
                let cmp = utility.InnoCmp[property];
                if (cmp.showInAddNewComponentMenu !== false && cmp.componentType == utility.ComponentType.DisplayComponent) {
                    components.push({
                        text: "Add " + property, onSelect: this.handleCreateNewElement.bind(this, row.rowItems, property, isParameter)
                    });
                }
            }
            components.sort((a, b) => a.text == b.text ? 0 : +(a.text > b.text) || -1);
            menuItems = menuItems.concat(components);
        }
        return menuItems;
    }

    createParameterItems = (parameterList, isParameter) => {
        let menuItems: any[] = [];
        let components: any[] = [];

        if (!utility.InnoCmp) {
            return menuItems
        }

        for (let property in utility.InnoCmp) {
            let cmp = utility.InnoCmp[property];
            if (cmp.showInAddNewComponentMenu !== false && cmp.componentType == utility.ComponentType.InputComponent) {
                components.push({ text: "Add " + property, onSelect: this.handleCreateNewElement.bind(this, parameterList, property, isParameter) });
            }
        }
        components.sort((a, b) => a.text == b.text ? 0 : +(a.text > b.text) || -1);
        menuItems = menuItems.concat(components);
        return menuItems;
    }

    createKendoTreeDataNode = (uiRows) => {
        let result = [];
        let that = this;
        if (!uiRows) {
            return null;
        }

        let treeNodes = uiRows.map(function (element): any {

            let nodeName = element.type;
            if (element.name != null) {
                nodeName = nodeName + ' ' + element.name;
            }
            let subtree: any;
            if (!element.uid) {
                element.uid = kendo.guid();
            }

            if (element.type == 'ROW') {

                subtree = that.createKendoTreeDataNode(element.rowItems);
                return { text: "Row", row: element, getUiRows: function () { return element.rowItems }, expanded: true, contextMenuData: that.createRowMenuItems(element, uiRows, false), items: subtree };
            }
            else if (element.type == 'PARAMETERGROUP') {
                if (!Array.isArray(element.parameters)) {
                    element.content = [];
                    element.parameters = [];
                }
                subtree = that.createParameterGroup(element);
                return { text: "PARAMETERGROUP", expanded: true, contextMenuData: [{ text: "Delete", onSelect: function () { this.handleDeleteElement(uiRows, element) } }], items: subtree, onSelect: that.handleElementClicked.bind(this, element) };
            } else if (element.type == 'REACTTABCONTROL') {
                if (!Array.isArray(element.tabs)) {
                    element.tabs = [];
                }
                subtree = that.createTabControl(element);
                return { text: nodeName, expanded: true, contextMenuData: [{ text: "Delete", onSelect: function () { this.handleDeleteElement(uiRows, element) } }], items: subtree, onSelect: that.handleElementClicked.bind(this, element) };
            }
            else if (element.type == 'REPEATER') {
                if (!element.rowItems) {
                    element.rowItems = [];
                }

                subtree = that.createKendoTreeDataNode(element.rowItems);
                return {
                    text: "REPEATER", expanded: true, contextMenuData: [
                        { text: "Delete", onSelect: function () { this.handleDeleteElement(uiRows, element) } },
                        { text: "Add row", onSelect: function () { that.handleAddListItem(element.rowItems, { "type": "ROW", "rowItems": [] }) } }
                    ], items: subtree, onSelect: that.handleElementClicked.bind(this, element)
                };
            }
            else if (element.type == 'REACTTAB') {
                if (!Array.isArray(element.content)) {
                    element.content = [];
                }

                return {
                    text: nodeName, expanded: true, contextMenuData: [{ text: "Delete", onSelect: function () { this.handleDeleteElement(uiRows, element) } }], items: [{ text: "Content", expanded: true, contextMenuData: [{ text: "Add row", onSelect: function () { that.handleAddListItem(element.content, { "type": "ROW", "rowItems": [] }) } }], onSelect: null, items: that.createKendoTreeDataNode(element.content) }]
                    , onSelect: that.handleElementClicked.bind(this, element)
                };
            }
            else {

                let cmp = utility.InnoCmp[element.type];
                return { text: nodeName, expanded: true, componentType: cmp.componentType, selected: (that.selectedElement == element), contextMenuData: [{ text: "Delete", onSelect: function () { this.handleDeleteElement(uiRows, element) } }, { text: "Copy", onSelect: function () { that.handleCopyElement(uiRows, element) } }], onSelect: that.handleElementClicked.bind(this, element) };
            }

        });

        return treeNodes;
    }

    createKendoTreeData = (ui) => {
        let that = this;
        if (!ui.parameters) {
            ui.parameters = [];
        }
        if (!ui.settings) {
            ui.settings = { "type": "SETTINGS" };
        }
        return new kendo.data.HierarchicalDataSource({
            data: [
                { text: "Settings", expanded: true, type: "SETTINGS", onSelect: that.handleElementClicked.bind(this, ui.settings) },
                { text: "Parameters", row: ui.parameters, getUiRows: function () { return ui.parameters }, expanded: true, contextMenuData: this.createParameterItems(ui.parameters, true), type: "PARAMETERS", items: this.createKendoTreeDataNode(ui.parameters) },
                { text: "UI", expanded: true, contextMenuData: [{ text: "Add row", onSelect: function () { that.handleAddListItem(ui.rows, { "type": "ROW", "rowItems": [] }) } }], type: "ROWS", items: this.createKendoTreeDataNode(ui.rows) }
            ]
        });
    }

    render() {
        if (this.props.ui) {
            return (<div style={{ height: "100%" }}>
                <KendoTreeViewWithNodeSpecificContextMenu id="uiJsonTree" onDragEnd={this.handleDrop} onDragStart={this.handleDragStart} onSelect={this.handleKendoTreeSelect} data={this.state.kendoTreeData} handleDeleteRow={this.handleDeleteRow} handleCreateNewElement={this.handleCreateNewElement} handleDeleteElement={this.handleDeleteElement} />
            </div>);
        }
        return <div>...</div>
    }
};

class KendoTreeViewWithNodeSpecificContextMenu extends React.Component<any, any>{

    private contextMenuRef: KendoContextMenu;
    constructor(props) {
        super(props);
        this.state = { contextMenuData: [] };
    }

    componentDidMount() {
        this.setState({ data: this.props.data });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ data: nextProps.data });
    }

    handleContextMenuCreation = (contextMenu) => {
    }

    handleContextMenuOpen = (e) => {
        let nodeData = this.state.data.getByUid($(e.target).attr("data-uid"));
        let contextMenu = [];
        if ((nodeData != null) && (nodeData.contextMenuData != null)) {
            // Es wird der Einfachheit halber nur eine flache Struktur mit Eigenschaften "text" für Menütext und "onSelect" für entsprechende Funktion unterstützt. Für mehr Eigenschaften muß das einfach erweitert werden.
            // Soll eine hierarchische Version unterstützt werden, muß dies in eine rekursive Funktion ausgelagert werden.
            let that = this;
            nodeData.contextMenuData.forEach(function (entry) {
                contextMenu.push({
                    text: entry.text,
                    onSelect: entry.onSelect,
                    handleCreateRow: that.props.handleCreateRow,
                    handleDeleteRow: that.props.handleDeleteRow,
                    handleCreateNewElement: that.props.handleCreateNewElement,
                    handleDeleteElement: that.props.handleDeleteElement
                });
            });
        }
        this.contextMenuRef.updateMenu(contextMenu);
    }

    handleContextMenuSelect = (e) => {
        // Bis heute unterstützt kendoMenu keinen gezielten Zugiff auf die Datasource, also muß getrickst werden, indem die Position des Menüeintrags zurch Abzählen bestimmt wird und dann entsprechender Eintrag rausgesucht wird.
        // Quelle: http://jsfiddle.net/MMRCf/8/light/
        let item = $(e.item),
            menuElement = item.closest(".k-menu"),
            dataItem = this.contextMenuRef.getDataSource(),
            index = item.parentsUntil(menuElement, ".k-item").map(function () {
                return $(this).index();
            }).get().reverse();
        index.push(item.index());
        for (let i = -1, len = index.length; ++i < len;) {
            dataItem = dataItem[index[i]];
            dataItem = i < len - 1 ? dataItem.items : dataItem;
        }

        // Auch wird das Übergeben von Funkeionen und hierarchicalDataSource von kendoMenu nicht unterstützt, deswegen wird kein reines JSON übergeben, sondern in das Objekt auch eine Funktion injiziert.
        if ($.isFunction(dataItem.onSelect)) {
            dataItem.onSelect();
        }
    }

    render() {
        return (<div id={this.props.id} style={{ height: "100%" }}>
            <react_components.KendoTreeView className="treeview" onSelect={this.props.onSelect} data={this.props.data} dragAndDrop="true" onDrop={this.props.onDragEnd} onDragStart={this.props.onDragStart} onDrag={this.props.onDrag} />
            <KendoContextMenu ref={(e) => { this.contextMenuRef = e }} className="treeviewContextmenu" orientation="vertical" target={"#" + this.props.id} filter=".k-item" onOpen={this.handleContextMenuOpen} onSelect={this.handleContextMenuSelect} onCreate={this.handleContextMenuCreation} data={this.state.contextMenuData} />
        </div>)
    }
};

class KendoContextMenu extends React.Component<any, any>{
    private contextMenu;
    private contextMenuRef;
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        let $rootNode = $(this.contextMenuRef);
        let contextMenu = $rootNode.kendoContextMenu({
            orientation: this.props.orientation,
            target: this.props.target,
            filter: this.props.filter,
            select: this.props.onSelect,
            open: this.props.onOpen,
            close: this.props.onClose,
            activate: this.props.onActivate,
            deactivate: this.props.onDeactivate
        });
        this.contextMenu = contextMenu.data("kendoContextMenu");
        this.props.onCreate(this.contextMenu);
    }

    componentWillUnmount() {
        this.contextMenu.destroy();
    }

    getDataSource = () => {
        return this.contextMenu.options.dataSource;
    }

    updateMenu(menuData) {
        if (this.contextMenu) {
            this.contextMenu.setOptions({
                dataSource: menuData
            })
        }
    }

    render() {
        return (

            <ul ref={(e) => { this.contextMenuRef = e }}>            
            </ul>
        )
    }
};